import ReportPairedProductNoveltyComparison from './ReportPairedProductNoveltyComparison';
export default ReportPairedProductNoveltyComparison;
